'use strict';

function FlightSummaryBookingIntakeToggleButtonsDirective($rootScope) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/flight-summary-booking-intake-buttons.html'),
    controller: 'FlightSummaryBookingIntakeToggleButtonsController',
    link: function link(scope) {
      scope.changeColumns = function (mode) {
        $rootScope.$broadcast('grid:changecolumns:flight-summary', mode);
      };
    }
  };
}
FlightSummaryBookingIntakeToggleButtonsDirective.$inject = ['$rootScope'];
module.exports = FlightSummaryBookingIntakeToggleButtonsDirective;